// extracted by mini-css-extract-plugin
module.exports = {"expenses-list":"ExpensesList_expenses-list__2Vr6m","expenses-list__fallback":"ExpensesList_expenses-list__fallback__38D1M"};